import { useState } from "react";
import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import authenticationImg from "../../../assets/images/illustration_scan_qr_code.svg";
import { useNavigate } from "react-router-dom";
import LoadingDialog from "../../commonComponents/loader/LoadingDialog";
import CommonSnackbar from "../../commonComponents/snackbar/CommonSnackbar";
import QRCode from "react-qr-code";
import { useLocation } from "react-router-dom";

const Authentication = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const location = useLocation();
  const redirectFrom = location.state?.redirectFrom;

  // Instead of OTP, you will have interviewId (static for demo)
  const interviewId = sessionStorage.getItem("interviewId");
  const companyId = sessionStorage.getItem("companyId");
  const timeRestriction = sessionStorage.getItem("time_restriction");
  const qrPayload = `${companyId},${interviewId},${timeRestriction}`;

  const handleProceed = () => {
    if (redirectFrom === "restored") {
      navigate("/assessment", {
        state: { redirectFrom: "restored" },
      });
    } else {
      navigate("/information");
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      {/* Header */}
      <Header />

      {loading && (
        <LoadingDialog
          title="Verifying QR Code"
          bottomMsg="This will be just a moment..."
        />
      )}

      {snackbar && (
        <CommonSnackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={() => setSnackbar(null)}
        />
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5  max-w-9xl">
        {/* Left Section */}
        <div className="w-full md:w-1/2 flex justify-center items-center pl-[34px] pr-[50px]">
          <img
            src={authenticationImg}
            alt="login qr"
            className="object-contain w-full max-w-[520px] h-auto rounded-3xl"
          />
        </div>

        <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-1 my-[5%]" />

        {/* Right Section */}
        <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
          <div className="max-w-[920px]">
            {/* Heading */}
            <h2
              className="font-semibold mb-4 leading-snug outer-font-color
       app-video-overlay"
            >
              Sync Assessment with NeedleEye
            </h2>

            <p className="text-fontColor mb-8 leading-relaxed text-base app-body outer-font-color">
              Scan the QR code below using your NeedleEye App to sync the
              assessment.
            </p>
          </div>

          <div className="flex flex-col items-center mt-5">
            <div className="bg-white p-4 shadow-lg rounded-xl">
              <QRCode value={qrPayload} size={220} />
            </div>
          </div>
        </div>
      </div>

      {/* Buttons container */}
      <div className="mt-auto w-full flex justify-end pb-4">
        <button
          className="btn-size flex bg-btnBgColor items-center justify-center px-6 py-1.5 text-white transition mr-[36px]"
          onClick={handleProceed}
        >
          Proceed
          <img src={arrowImg} alt="arrowImg" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
    © {new Date().getFullYear() > 2026 ? `2026-${new Date().getFullYear()}` : '2026'}, Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default Authentication;
